import type { PaymentSettings } from '@/hooks/usePaymentSettings';

export const MOCK_PAYMENT_SETTINGS: PaymentSettings = {
  onboardingCompleted: false,
  onboardingCompletedAtUtc: null,
  onboardingUpdatedAtUtc: null,
  paymentLinksAvailable: false,
  bannerDismissed: false,
  bannerUpdatedAtUtc: null,
};
